/** The outbox topic crosses a process boundary (API/runtime -> worker), so it ships a schema. */
import { z } from "zod";
import { idSchema } from "../id/schema.js";
import { accountId, workspaceId } from "../id/codec.js";
import { OUTBOX_TOPIC } from "./outbox-message.js";
export const OutboxTopicSchema = z.enum(OUTBOX_TOPIC);
/** The shape `Outbox.enqueue` accepts, as it is written to the row. */
export const OutboxEnqueueSchema = z
    .object({
    topic: OutboxTopicSchema,
    accountId: idSchema(accountId),
    workspaceId: idSchema(workspaceId).optional(),
    payload: z.unknown(),
    availableAt: z.date().optional(),
})
    .strict();
//# sourceMappingURL=outbox-message.schema.js.map